import { combineReducers } from './combineReducers';
import { loggerReducer } from './user/user.reducer';

export const initialState: AppState = {
  user: {
    darkMode: false,
    isLoggedin: false,
    loading: false,
    authToken: '',
    refreshToken: '',
  }
};

export const reducers = combineReducers({
  user: loggerReducer
});

export type AppState = ReturnType<typeof reducers>;